import type { WorkerListItem } from "@/store/jobs";

export type WorkerOption = {
    id: number
    label: string
    status?: string
    type: 'item'
}

export type WorkerGroupOption = {
    id: number
    label: string
    type: 'group'
    selectable: boolean
    children: WorkerOption[]
}

export type WorkerSelectOption = WorkerOption | WorkerGroupOption

// Бэк отдаёт плоский список, где вперемешку идут отдельные работники и отделы со
// вложенными работниками. У отделов своего id нет, поэтому синтетический id строится
// от позиции в общем массиве — в модель выбора он не попадает, нужен только для :key
// и поиска исходной группы внутри AppSelect.
const GROUP_ID_OFFSET = 999999

export function buildWorkerOptions(workers: WorkerListItem[] | null): WorkerSelectOption[] {
    if (!workers) {
        return []
    }

    return workers.map((el, index) => {
        if (el.IsWorker) {
            return {
                id: el.Worker?.Id,
                label: el.Worker?.Name,
                status: el.Worker?.Status,
                type: 'item'
            } as WorkerOption
        }

        return {
            id: index + GROUP_ID_OFFSET,
            label: el.Departament.Name,
            type: 'group',
            selectable: true,
            children: el.Departament.Workers?.map(worker => ({
                id: worker.Id,
                label: worker.Name,
                status: worker.Status,
                type: 'item'
            }))
        } as WorkerGroupOption
    })
}

// Ищет работника в исходных данных: сначала среди отдельных работников, затем внутри
// отделов. Возвращает опцию с настоящим Worker.Id — синтетические id сюда попадать не
// должны, иначе такой id уедет в WorkerIds и на бэк.
export function findWorkerOption(
    workers: WorkerListItem[] | null,
    workerId: number | null | undefined
): WorkerOption | null {
    if (!workers || workerId == null) {
        return null
    }

    for (const el of workers) {
        if (el.IsWorker) {
            if (el.Worker && el.Worker.Id === workerId) {
                return {
                    id: el.Worker.Id,
                    label: el.Worker.Name,
                    status: el.Worker.Status,
                    type: 'item'
                }
            }
            continue
        }

        const found = el.Departament?.Workers?.find(worker => worker.Id === workerId)
        if (found) {
            return {
                id: found.Id,
                label: found.Name,
                status: found.Status,
                type: 'item'
            }
        }
    }

    return null
}
